// extracted by mini-css-extract-plugin
export default {"deleteGroupButton":"TemplateGroupModal_deleteGroupButton__b0bWA","confirmOverlay":"TemplateGroupModal_confirmOverlay__cISny"};